import React from "react";
import styled from "styled-components";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import { Container } from "react-bootstrap";

const Kits = () => (
  <Wrapper>
    <Container>
      <UnderlinedHeader text={"4X4 SPECIALIST KITS"} bolder />
      <p>
        TrakRyder 4WD Suspension represents many years of technical development
        and delivers new levels of ride and comfort for the 4-wheel drive owner.
      </p>
      <p>
        Pedders TrakRyder suspension includes hundreds of quality components in
        its construction each designed to improve the ride and handling of
        specific vehicles in specific ways. The success of the Pedders TrakRyder
        4WD suspension system is not governed by product alone.
      </p>
      <p>
        TrakRyder is a tailored system and much of its prowess can be attributed
        to the fact that the system can be 'custom built' to suit any 4x4
        vehicle.With TrakRyder it is possible to enjoy all the aspirational
        tough qualities of a 4-wheel drive escape vehicle yet with the handling
        and ride characteristics of a sedan.
      </p>
      <p>
        With TrakRyder it is possible to enjoy all the aspirational tough
        qualities of a 4-wheel drive escape vehicle yet with the handling and
        ride characteristics of a sedan.
      </p>
      <p>
        For owners of newer vehicles, TrakRyder brings an end to the age-old
        compromise of owning a 4-wheel drive and having to compromise on ride
        and comfort.
      </p>
      <p>
        Whether it be for every day driving, lift kits or towing and load
        carrying you can be rest assured that Pedders Suspension can tailor a
        TrakRyder suspension system to suit your driving needs.
      </p>
      <Bolder>
        TrakRyder System offers on road comfort with off road control
      </Bolder>
      <p>
        Whether it be for every day driving, lift kits or towing and load
        carrying, you can rest assured that your local Pedders Suspension
        specialist can tailor a TrakRyder 4WD suspension system to suit your
        driving needs.
      </p>
      <Bolder>
        Call your local Pedders Suspension store today to order your Trakryder
        4WD Suspension or call to request a quote on a tailored TrakRyder
        System.
      </Bolder>
      <Bolder>The Pedders TrakRyder Range consists of:</Bolder>
      <ul>
        <li>Shock Absorbers</li>
        <li>Coil Springs</li>
        <li>Leaf Springs</li>
        <li>Rubber Bushes</li>
        <li>Urethane Bushes</li>
        <li>Steering Dampers</li>
        <li>Shackle Kits</li>
        <li>Air Bags</li>
        <li>Torsion Bars</li>
        <li>Chassis & Steering Parts</li>
        <li>Strut Mounts</li>
        <li>U Bolts</li>
        <li>Wheel Alignment Products</li>
        <li>Four Wheel Drive 4 Wheel Alignment</li>
      </ul>
    </Container>
  </Wrapper>
);

export default Kits;

const Wrapper = styled.section`
  padding-top: 92px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #666666;
`;

const Bolder = styled.p`
  font-weight: 600;
  font-size: 16px;
`;
